import "./get_in_touch_view.css";
import Button from "../../../core/components/buttons/secundary_button/secundary_button.jsx";
import { FaChevronRight } from "react-icons/fa6";
import { getInTouchMapper } from "../utils/mapper/get_in_touch_mapper.jsx";

const GetInTouchView = () => {
    const { title } = getInTouchMapper;
    return (
        <div className="get_in_touch">
            <div className="container">
                <h1>{title}</h1>
                <div className="button_contact">
                    <Button
                        className="get_in_touch_cta"
                        style_border="solid 1px #9E9E9E"
                        title="Entrar em contato"
                        borderRadius="9px"
                        icon={<FaChevronRight />}
                    />
                </div>
            </div>
        </div>
    );
};

export default GetInTouchView;
